/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Image, NavDropdown } from "react-bootstrap";
import {
  faBars,
  faChevronDown,
  faChevronRight,
  faCircleXmark,
  faEllipsisVertical,
  faEye,
  faFile,
  faFolder,
  faFolderOpen,
  faMagnifyingGlass,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IMAGES } from "../../constants/imagePath";
import useAxios from "../../hooks/useAxios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINTS } from "../../constants/api";
import { debounce, formatDate } from "../../utils/helper";
import XConfirm from "../../component/confirm/XConfirm";
import { toaster } from "../../utils/toast";
import { useNavigate } from "react-router-dom";
import XModal from "../../component/modal/XModal";
import useSidebar from "../../hooks/useSidebar";
import PaginationNav from "../../component/pagination/pagination";
import XLoader from "../../component/loader/XLoader";
import { PermissionObject } from '../../redux/modules/auth/types';
import { CampaignType } from "../../utils/enums";
import { RootState } from "../../redux/rootReducer";

type DataType = {
  [key: string]: any;
};

type OptionsMapping = {
  [key: string]: { sortBy: string; orderBy: string };
};

type FilterType = {
  search: string;
  sortBy: string;
  orderBy: string;
  folder_id: number;
  pageNumber: number;
  itemPerPage: number;
  type: string;
};

interface ContentProps {
  permission?: PermissionObject
}

const ContentLibrary: React.FC<ContentProps> = (props) => {
  const { permission } = props;
  const [data, setData] = useState<DataType[]>([]);
  const [deleteTemplateId, setDeleteTemplateId] = useState<string>("");
  const [previewHtml, setPreviewHtml] = useState<string>("");
  const [totalCount, setTotalCount] = useState(0);
  const itemPerPage = 10;
  const navigate = useNavigate();
  const { onShowSidebar } = useSidebar();
  const { orgLocations, selectedLocationId } = useSelector((state: RootState) => state.user);

  const activeLocation = (orgLocations ?? []).find(
    (loc: any) => String(loc.id) === String(selectedLocationId)
  ) || (orgLocations && orgLocations.length > 0 ? orgLocations[0] : null);

  const locationTimezone = activeLocation?.location_timezone || 'UTC';

  const [filter, setFilter] = useState<FilterType>({
    search: "",
    sortBy: "updated_at",
    orderBy: "desc",
    folder_id: 0,
    pageNumber: 1,
    itemPerPage: itemPerPage,
    type: CampaignType.EMAIL,
  });

  const totalPages = Math.ceil(totalCount / itemPerPage);

  const { postData, isLoading } = useAxios();
  const [expandedFolders, setExpandedFolders] = useState<number[]>([]);
  const [editFolderId, setEditFolderId] = useState<number | null>(null);
  const [editFolderName, setEditFolderName] = useState("");
  const [deleteFolderId, setDeleteFolderId] = useState<number | null>(null);


  useEffect(() => {
    fetchTemplate();
  }, [filter, selectedLocationId]);

  const columns = [
    {
      title: "Preview",
      type: "img",
      onClick: (value: any) => {
        setPreviewHtml(value.content);
        // openNewTabWithHTML(value.content);
      },
      imgData: {
        src: IMAGES.previewThumbnail,
      },
    },
    {
      title: "Name",
      dataField: "name",
    },
    {
      title: "Last Updated",
      dataField: "updated_at",
      wrapperFunc : formatDate
    },
  ];

  const actions = {
    title: "Action",
    type: "action",
    data: [
      {
        title: "Delete",
        onClick: (v: any) => {
          setDeleteTemplateId(v.id);
        },
        className: "delete",
        icon: faCircleXmark,
      },
      {
        title: "Edit",
        onClick: (v: any) => {
          navigate(`/org/content/create-email-content/${v.id}`, {
            state: { editTemplateData: v },
          });
        },
        className: "edit",
        icon: faPenToSquare,
      },
    ],
  };

  // const openNewTabWithHTML = (htmlContent: any) => {
  //   const newWindow = window.open("", "_blank");
  //   newWindow?.document.write(htmlContent);
  // };

  const handlePageChange = (pageNumber: number) => {
    setFilter((prevFilter) => ({ ...prevFilter, pageNumber }));
  };

  const handleSearchChange = (search: string) => {
    setFilter((prevFilter) => ({ ...prevFilter, search, pageNumber: 1 }));
  };

  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;

    const optionsMapping: OptionsMapping = {
      "1": { sortBy: "updated_at", orderBy: "desc" }, // Newest First
      "2": { sortBy: "updated_at", orderBy: "asc" }, // Oldest First
      "3": { sortBy: "name", orderBy: "asc" }, // A-Z
      "4": { sortBy: "name", orderBy: "desc" }, // Z-A
    };

    setFilter((prevFilter) => ({
      ...prevFilter,
      ...optionsMapping[selectedValue],
    }));
  };

  const fetchTemplate = async () => {
    try {
      const response = await postData(API_ENDPOINTS.GET_ALL_TEMPLATE_WITH_FOLDER, { filter });
      setData(response?.data?.folders ?? []);
      setTotalCount(response?.data?.totalCount ?? 0);
    } catch (error) {}
  }

  const debouncedHandleSearchChange = debounce(handleSearchChange, 500);

  const deleteHandler = async () => {
    try {
      const response = await postData(API_ENDPOINTS.DELETE_TEMPLATE, {
        templateId: deleteTemplateId,
      });
      const { message, success } = response;
      if (success) {
        setData((prevData) =>
          prevData.filter((v) => v.id !== deleteTemplateId)
        );
        setDeleteTemplateId("");
        fetchTemplate();
      }
      toaster({ message, success });
    } catch (error) {
      toaster({ message: "An error occurred", success: false });
      setDeleteTemplateId("");
    }
  };

  const toggleFolder = (folderId: number) => {
    setExpandedFolders(prev =>
      prev.includes(folderId)
        ? prev.filter(id => id !== folderId)
        : [...prev, folderId]
    );
  };

  const deleteFolderHandler = async () => {
    try {
      const response = await postData(API_ENDPOINTS.DELETE_FOLDER, {
        folderId: deleteFolderId,
      });
      const { success, message } = response;
      toaster({ message, success });
      fetchTemplate();
      setDeleteFolderId(null)
    } catch (error) {}
  };
  
  const editFolderHandler = async () => {
    try{
      const response = await postData(API_ENDPOINTS.CREATE_FOLDER, {
        folderId: editFolderId, name: editFolderName, type: CampaignType.EMAIL
      });
      const { success, message } = response;
      if(success) {
        fetchTemplate();
        setEditFolderId(null);
        setEditFolderName("");
      }
      toaster({ message, success });
    } catch(error){}
  };

  return (
    <div>
      {previewHtml && (
        <XModal
          title="Email Preview"
          show={!!previewHtml}
          handleClose={() => setPreviewHtml("")}
          size="xl"
          body={
            <div style={{ maxHeight: "67vh", overflowY: "auto" }}>
              <div
                style={{ pointerEvents: 'none' }}
                dangerouslySetInnerHTML={{
                  __html: previewHtml ?? "",
                }}
              />
            </div>           
          }
        />
      )}
      {deleteTemplateId && (
        <XConfirm
          show={!!deleteTemplateId}
          onCancel={() => setDeleteTemplateId("")}
          onConfirm={deleteHandler}
          isLoading={isLoading}
        />
      )}
      {deleteFolderId !== null && (
        <XConfirm
          show={deleteFolderId !== null}
          onCancel={() => setDeleteFolderId(null)}
          onConfirm={deleteFolderHandler}
          isLoading={isLoading}
          message={
            <>
              Are you sure you want to delete this folder?
              All templates inside this folder will also be permanently deleted.
            </>
          }
        />
      )}

      {editFolderId !== null && (
        <XModal
          title={"Edit Folder"}
          show={editFolderId !== null}
          handleClose={()=>{
            setEditFolderId(null);
            setEditFolderName("");
          }}
          cancelText="Cancel"
          confirmText="Update"
          handleConfirm={editFolderHandler}
          body={
            <div>
              <Form.Label className="mb-0">
                Enter Folder Name
              </Form.Label>
              <Form.Control
                type="text"
                className="form-control"
                placeholder="Enter"
                value={editFolderName}
                onChange={(e) => setEditFolderName(e.target.value)}
              />
            </div>
          }
        />
      )}

      <div className="main-title d-flex align-items-center justify-content-between">
        <h2 className="d-flex align-items-center">
          <span className="d-lg-none cursor-pointer" onClick={()=>onShowSidebar()}>
            <FontAwesomeIcon icon={faBars} />
          </span>
          Email Content Library
        </h2>
        {permission?.edit && 
          <Button
            variant="primary"
            onClick={() => navigate("/org/content/create-email-content")}
            className="btn-theme"
          >
            Create Email Template
          </Button>
        }
      </div>
      <div className="content-library">
        <div className="filter-bar d-flex align-items-center justify-content-between w-100">
          <div className="position-relative search-bar">
            <Form.Control
              type="search"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => debouncedHandleSearchChange(e.target.value)}
            />
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </div>
          <div className="select-box d-flex align-items-center w-100 justify-content-end">
            <Form.Group
              className="d-flex align-items-center"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Label>Sort By</Form.Label>
              <Form.Select
                aria-label="Default select example"
                onChange={handleSortChange}
              >
                <option value="">Select</option>
                <option value="1">Newest First</option>
                <option value="2">Oldest First</option>
                <option value="3">A-Z</option>
                <option value="4">Z-A</option>
              </Form.Select>
            </Form.Group>
          </div>
        </div>

          <div>
            <div className="table-listing position-relative">
              <div className="multilevel-folders-view">
                <h6 className="mb-3  multilevel-header">Email Templates By Folder</h6>
                <div className="content-library">
                  {!isLoading && data?.length === 0 && (
                    <div className="no-folders-container text-center py-4">
                      <FontAwesomeIcon icon={faFolderOpen} size="3x" className="mb-3" style={{ color: '#ccc' }} />
                      <p className="no-folders-text">No Email folders or templates found.</p>
                    </div>
                  )}
                  {!isLoading && data.map((folder) => {
                    const isOpen = expandedFolders.includes(folder.folder_id);
                    return (
                      <div key={folder.folder_id} className="folder-block">
                        {/* Folder Header */}
                        <div className="folder-header" >
                          <div onClick={() => toggleFolder(folder.folder_id)}>
                            <FontAwesomeIcon className="me-3" icon={isOpen ? faChevronDown : faChevronRight} size="sm" />
                            <div className="position-relative d-inline-block me-3">
                              <FontAwesomeIcon icon={isOpen ? faFolderOpen : faFolder} size="lg" style={{ color: "#13294b" }} />
                              <span className="template-count-badge">{folder.templates.length}</span>
                            </div>
                            <span className="folder-name">{folder.folder_name} </span>
                          </div>
                          {/* Folder Action Icons Web */}
                          <div className="action-badges hide-mobile">
                            <button className="delete" onClick={() => setDeleteFolderId(folder.folder_id)}>
                              Delete <FontAwesomeIcon icon={faCircleXmark} className="ms-1" />
                            </button>
                            <button className="edit" onClick={() => {
                              setEditFolderId(folder.folder_id)
                              setEditFolderName(folder.folder_name);
                            }}>
                              Edit <FontAwesomeIcon icon={faPenToSquare} className="ms-1" />
                            </button>
                          </div>

                          {/* Folder Action Icons Mobile */}
                          <span className="profile hide-dropdown-arrow hide-web">
                            <NavDropdown title={<FontAwesomeIcon icon={faEllipsisVertical} />} align="end">
                              <NavDropdown.Item onClick={() => {
                                setEditFolderId(folder.folder_id)
                                setEditFolderName(folder.folder_name);
                              }}>
                                <FontAwesomeIcon icon={faPenToSquare} className="me-2" />
                                Edit
                              </NavDropdown.Item>
                              <NavDropdown.Item onClick={() => setDeleteFolderId(folder.folder_id)}>
                                <FontAwesomeIcon icon={faCircleXmark} className="me-2" />
                                Delete
                              </NavDropdown.Item>
                            </NavDropdown>
                          </span>
                        </div>

                        {/* Templates */}
                        {isOpen && (
                          <div className="template-list">
                            {folder.templates.map((template: any) => (
                              <div key={template.id} className="template-row">
                                <div className="template-info">
                                  <FontAwesomeIcon size="lg" className="me-3" icon={faFile}/>
                                  {template.name}
                                </div>
                                <Image className="cursor-pointer hide-mobile" src={IMAGES.previewThumbnail} alt="Preview" onClick={() => setPreviewHtml(template.content)} />
                                <span className="template-date text-start">{formatDate(template.updated_at, locationTimezone)}</span>
                                <div className="d-flex justify-content-between mt-2">
                                <div className="tree-item-mobile-actions hide-web">
                                  <button
                                    className="preview-btn"
                                    onClick={() => setPreviewHtml(template.content)}
                                  >
                                    <FontAwesomeIcon icon={faEye} className="me-1" />
                                    Preview
                                  </button>
                                </div>
                              
                                <div className="action-badges">
                                  {actions.data.map((action, index) => (
                                    <button
                                      className={`border-0 ${action.className}`}
                                      onClick={() => action.onClick?.(template)}
                                    >
                                      <FontAwesomeIcon icon={action.title === 'Delete' ? faCircleXmark : faPenToSquare}/>
                                    </button>
                                  ))}
                                </div>
                                </div>
                                
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* ------------------- */}
              {isLoading && <XLoader />}
            </div>
            {!isLoading && data?.length !== 0 && (
              <PaginationNav
                totalPages={totalPages}
                currentPage={filter.pageNumber}
                handlePageChange={handlePageChange}
              />
            )}
          </div>
      </div>
    </div>
  );
};

export default ContentLibrary;
